import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

// Retorno da Shopify aberto DENTRO do admin (app marcado como incorporado): o login do painel
// não roda em iframe. Tenta abrir na janela principal; se o navegador bloquear, o clique do
// lojista no link (navegação com interação do usuário) resolve.
const ShopifyEmbeddedBreakout: React.FC = () => {
  const intl = useIntl();
  const url = window.location.href;

  useEffect(() => {
    try {
      window.top!.location.href = url;
    } catch {
      // Bloqueado pelo sandbox do iframe: fica o link abaixo
    }
  }, [url]);

  return (
    <div className='d-flex flex-column align-items-center justify-content-center text-center p-10 min-vh-100'>
      <p className='fs-5 text-gray-700 mb-6'>
        {intl.formatMessage({
          id: 'platform-migration.shopify-embedded.body',
          defaultMessage: 'Para continuar a conexão da sua loja, abra o painel da Konfidency fora do admin da Shopify.',
        })}
      </p>
      <a href={url} target='_top' rel='noopener' className='btn btn-primary mb-3'>
        {intl.formatMessage({ id: 'platform-migration.shopify-embedded.open', defaultMessage: 'Continuar no painel da Konfidency' })}
      </a>
      <a href={url} target='_blank' rel='noopener noreferrer' className='btn btn-link'>
        {intl.formatMessage({ id: 'platform-migration.shopify-embedded.new-tab', defaultMessage: 'Abrir em uma nova aba' })}
      </a>
    </div>
  );
};

export default ShopifyEmbeddedBreakout;
